import { render } from "./weight-cost.vue?vue&type=template&id=3097b6eb&scoped=true&ts=true"
import script from "./weight-cost.vue?vue&type=script&lang=ts"
export * from "./weight-cost.vue?vue&type=script&lang=ts"

import "./weight-cost.vue?vue&type=style&index=0&id=3097b6eb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3097b6eb"]])

export default __exports__